import { } from "@mui/material";
import { useEffect, useState } from "react";
import BottomButton from "../components/BottomButton";
import { useStyles } from "../styles/useStyles";

import _175cc_img from "../../assets/175cc_img.png";
import banner from "../../assets/banner.jpg";
import logo from "../../assets/logo.jpg";
import rescue_process_1 from "../../assets/rescue-process-step1.jpg";
import rescue_process_2 from "../../assets/rescue-process-step2.jpg";
import rescue_process_3 from "../../assets/rescue-process-step3.jpg";
import checklist_icon from "../../assets/check_ok_icon.svg";
import i_icon from "../../assets/i_icon.svg";
import icon_expand_more from "../../assets/icon_expand_more.svg";
import icon_expand_less from "../../assets/icon_expand_less.svg";
import zalo_icon from "../../assets/zalo_icon.svg";
import phone_icon from "../../assets/phone_icon.svg";
import email_icon from "../../assets/email_icon.svg";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MDCompanyInfo from "../components/MDCompanyInfo";


const arrayLink = [
  {
    title: "Mẫu hợp đồng",
    link: "https://cdn.globalcare.vn//private/pdf/zuttoride/zuttoride_mhd.pdf",
  },
  // { title: "Tài liệu bán hàng", link: "" },
  // { title: "Salekit", link: "" },
];

const benefitsList = [
  "Hỗ trợ bơm vá lốp xe miễn phí",
  "Hỗ trợ miễn phí kích bình khởi động xe khi bình không sạc",
  "Hỗ trợ tiếp xăng (Giá xăng theo thị trường)",
  "Vận chuyển miễn phí 50km đối với phương tiện dưới 175cc và 300km đối với phương tiện trên 175cc từ vị trí của khách hàng. Phụ thu khách hàng 100,000VNĐ trên 10km khi vượt quá giới hạn km được miễn phí.",
];

const rescueSteps = [
  {
    img: rescue_process_1,
    title: "Bước 1",
    content: "Hãy gọi đến tổng đài 1900969612",
  },
  {
    img: rescue_process_2,
    title: "Bước 2",
    content: "Nhân viên sẽ có mặt với bạn",
  },
  {
    img: rescue_process_3,
    title: "Bước 3",
    content: "Hỗ trợ tận nơi",
  },
];


export default function Introduce({ state, dispatch, platform }) {
  const [noteCardOpen, setNoteCardOpen] = useState(false);
  const [isNoteCardClosing, setIsNoteCardClosing] = useState(false);
  const [openCompanyInfo, setOpenCompanyInfo] = useState(false);
  const { loadingPrice } = state;
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const OpenLink = (link) => {
    if (platform === "app") {
      // History.replace(`/gotoBrownser?link=${link}`);
      window.ReactNativeWebView.postMessage(`/gotoBrownser?link=${link}`);
    } else {
      window.open(link, "_blank");
    }
  };
  return (
    <>
      <div className={classes.wrapper} style={{ background: "#F3F3F3", padding: 0 }}>
        <img src={banner} width={"100%"} />
        <div style={{ padding: 16, background: "white", textAlign: "center" }}>
          <img src={logo} height={81} />
        </div>
        <div style={{ padding: "16px 10px 16px 10px", background: "#F3F3F3", textAlign: "center", gap: "16px", display: "flex", flexDirection: "column" }}>
          <span style={{
            color: "#343A40",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "24px",
            fontFamily: "Inter, sans-serif",
          }}> QUYỀN LỢI </span>
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <div style={{ textAlign: "justify", lineHeight: "140%" }}>
              Sử dụng dịch vụ{" "}
              <span style={{ fontWeight: "600" }}>
                cứu hộ xe máy 24/7 trên cả nước
              </span>, bao gồm hỗ trợ khắc phục
              tạm thời và tại chỗ các hư hỏng do tai nạn hoặc sự cố kỹ thuật như:
            </div>

            {benefitsList.map((text, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                <img src={checklist_icon} alt="checklist" style={{ width: 20, height: 20 }} />
                <div style={{ textAlign: "justify", lineHeight: "140%" }}>{text}</div>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                borderRadius: noteCardOpen || isNoteCardClosing ? "10px 10px 0 0" : 10,
                padding: "10px 16px",
                justifyContent: "space-between",
                display: "flex",
                border: "none",
                backgroundColor: "#FFFFFF",
                color: "#009B4B",
                fontSize: "14px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                if (noteCardOpen) {
                  setIsNoteCardClosing(true);
                }
                setNoteCardOpen(!noteCardOpen);
              }}
            >
              <span>Lưu ý</span>
              {noteCardOpen ? (
                <img src={icon_expand_less} />
              ) : (
                <img src={icon_expand_more} />
              )}
            </div>
            <div
              style={{
                overflow: "hidden",
                maxHeight: noteCardOpen ? 1000 : 0,
                transition: "max-height 0.6s ease",
              }}
              onTransitionEnd={() => {
                if (!noteCardOpen) {
                  setIsNoteCardClosing(false);
                }
              }}
            >
              <div
                style={{
                  background: "#FFFFFF",
                  padding: "10px 16px",
                  borderRadius: "0 0 10px 10px",
                  textAlign: "justify",
                  display: "flex",
                  flexDirection: "column",
                  gap: 5,
                }}
              >
                <div style={{ lineHeight: "150%", fontSize: 14 }}>
                  1. Phạm vi dịch vụ của ZuttoRide tại các khu vực chưa hỗ trợ cứu hộ
                  cho khách hàng thành viên đăng ký cho dòng xe phân khối nhỏ (
                  <span>&lt;=175cc</span>) đến thời điểm hiện tại 2024 bao gồm: Bắc
                  Kạn, Cao Bằng, Điện Biên, Hà Giang, Hòa Bình, Lai Châu (Dựa trên địa
                  giới cũ)
                </div>
                <div style={{ lineHeight: "150%", fontSize: 14 }}>
                  2. Khu vực Quảng Ninh, Hà Tĩnh dòng xe phân khối nhỏ chỉ hỗ trợ tại:
                  Tp.Hạ Long, Đông Triều, Tp.Hà Tĩnh.
                </div>
                <div style={{ lineHeight: "150%", fontSize: 14 }}>
                  3. Đối với khách hàng thành viên phân khối lớn (xe &gt;175cc): Hỗ
                  trợ cứu hộ cho khách hàng gặp sự cố tại 63 tỉnh thành phố thuộc lãnh
                  thổ Việt Nam
                </div>
                <div style={{ lineHeight: "150%", fontSize: 14 }}>
                  4. Riêng khu vực biển/đảo: Dịch vụ cứu hộ không hỗ trợ cho tất cả
                  đối tượng khách hàng.
                </div>
                <div style={{ lineHeight: "150%", fontSize: 14 }}>
                  5. Khu vực biển/đảo không hỗ trợ dịch vụ có thể hiểu là hệ thống các
                  đảo ven bờ và hệ thống các đảo xa bờ thuộc lãnh thổ Việt Nam phải
                  dùng phương tiện đường biển/hàng không (ví dụ:
                  tàu/thuyền/cáp treo/máy bay/…) để di chuyển từ vị trí đất liền để
                  tiếp cận.
                </div>
                <div style={{ lineHeight: "150%", fontSize: 14 }}>
                  6. Hiện tại dịch vụ cứu hộ ZuttoRide chỉ có thể cung cấp đến khách
                  hàng gặp sự cố trên phạm vi đất liền tại các tỉnh thành đã triển khai
                  dịch vụ.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: "16px 10px", display: "flex", flexDirection: "column", gap: "16px" }}>
          <div style={{
            fontSize: 16,
            fontWeight: 600,
            textAlign: "center"
          }}>
            QUY TRÌNH CỨU HỘ
          </div>
          <div style={{ display: "flex", gap: "8px", justifyContent: "space-between" }}>
            {rescueSteps.map((step, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  textAlign: "center",
                  flex: 1
                }}
              >
                <img
                  src={step.img}
                  style={{ borderRadius: "8px", width: "100%" }}
                />
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>{step.title}</div>
                  <div>{step.content}</div>
                </div>
              </div>
            ))}
          </div>

        </div>
        <div style={{ padding: "16px 10px", display: "flex", flexDirection: "column", gap: "8px" }}>
          {arrayLink.map((item, index) => (
            <div
              key={item.title}
              onClick={() => {
                item.link && OpenLink(item.link);
              }}
              style={{
                background: "white",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                paddingRight: 12,
                paddingLeft: 12,
                height: 40
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "-webkit-fill-available",
                }}
              >
                <img src={i_icon} alt="i_icon" style={{ display: "block" }} />
                <span style={{ marginLeft: "8px", fontSize: "14px" }}>
                  {item.title}
                </span>
              </div>

              <ChevronRightIcon sx={{ color: "#646D69" }} />
            </div>
          ))}
          <div
            onClick={() => setOpenCompanyInfo(true)}
            style={{
              background: "white",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              paddingRight: 12,
              paddingLeft: 12,
              height: 40
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "-webkit-fill-available",
              }}
            >
              <img src={i_icon} alt="i_icon" style={{ display: "block" }} />
              <span style={{ marginLeft: "8px", fontSize: "14px" }}>
                Thông tin công ty đối tác
              </span>
            </div>
            <ChevronRightIcon sx={{ color: "#646D69" }} />
          </div>
        </div>
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "16px 0px"
        }}>

          <div
            style={{
              width: "100%",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            Liên hệ CSKH để được{" "}
            <span style={{ color: "#009B4B" }}>hỗ trợ</span> và{" "}
            <span style={{ color: "#009B4B" }}>hướng dẫn</span> .
          </div>
          <div
            style={{
              display: "flex",
              paddingBottom: "12px",
              width: "65%",
              justifyContent: "space-around",
              width: "100%",
            }}
          >
            <div key="zalo" style={{ margin: "0 12px" }}>
              <a
                onClick={() => {
                  if (platform === "app") {
                    window.ReactNativeWebView.postMessage("/gotozalo");
                  } else {
                    window.open(
                      "https://chat.zalo.me/?c=648487566003209799",
                      "_blank"
                    );
                  }
                }}
                style={{
                  borderRadius: "50%",
                  backgroundColor: "#009B4B",
                  width: 45,
                  height: 45,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={zalo_icon}
                  alt="zalo"
                />
              </a>
            </div>

            <div key="phone" style={{ margin: "0 12px" }}>
              <a
                style={{
                  borderRadius: "50%",
                  backgroundColor: "#009B4B",
                  width: 45,
                  height: 45,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => window.open("tel:1900292987", "_blank")}
              >
                <img
                  src={phone_icon}
                  alt="zalo"
                />
              </a>
            </div>

            <div key="mail" style={{ margin: "0 12px" }}>
              <a
                onClick={() =>
                  window.open("mailto:cskh@globalcare.com.vn", "_blank")
                }
                style={{
                  borderRadius: "50%",
                  backgroundColor: "#009B4B",
                  width: 45,
                  height: 45,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={email_icon}
                  alt="zalo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <BottomButton
        disabled={loadingPrice}
        onBack={false}
        onClick={() => dispatch("nextPage")}
        title="Tiếp tục"
      />
      <MDCompanyInfo open={openCompanyInfo} onClose={() => setOpenCompanyInfo(false)} />
    </>
  );
}
